const DEFAULT_FADE_BAND = 0.5;
export function projectedLabelFontPixels(args) {
    if (args.perspective && args.cameraDepth <= 0)
        return 0;
    return args.worldFontSize * Math.abs(args.projectionScale) * args.viewportHeight / 2
        / (args.perspective ? args.cameraDepth : 1);
}
/** Text begins appearing at the readable pixel threshold and reaches full opacity 25% above it. */
export function resolveFlagTextOpacity(projectedFontPixels, minTextPixels) {
    return Math.max(0, Math.min(1, (projectedFontPixels / minTextPixels - 1) / 0.25));
}
/**
 * Apparent size is `fontSize / distance`, so the gate holds when font size, field of view or global
 * geometry scale change. Returns a multiplier for the label's own opacity.
 */
export function resolveLabelProximityOpacity(args) {
    const { distance, fontSize, proximity } = args;
    if (!Number.isFinite(distance) || distance <= 0)
        return 1;
    const apparentSize = fontSize / distance;
    const minApparentSize = proximity.minApparentSize;
    if (minApparentSize <= 0)
        return 1;
    if (apparentSize <= minApparentSize)
        return 0;
    // Ramping over a band rather than switching at a threshold keeps labels from popping during orbit.
    const fadeBand = proximity.fadeBand ?? DEFAULT_FADE_BAND;
    if (fadeBand <= 0)
        return 1;
    const fullyVisibleAt = minApparentSize * (1 + fadeBand);
    if (apparentSize >= fullyVisibleAt)
        return 1;
    return (apparentSize - minApparentSize) / (fullyVisibleAt - minApparentSize);
}
